import {
  CREATE_MENU_LINK_SUCCESS,
  CREATE_MENU_LINK_ERROR,
  FETCH_MENU_LINKS_LIST,
  FETCH_MENU_LINKS_LIST_ERROR,
  CLEAR_FETCH_MENU_LINKS_LIST,
  CLEAR_CREATE_MENU_LINK,
  DELETE_MENU_LINK_SUCCESS,
  DELETE_MENU_LINK_ERROR,
  CLEAR_DELETE_MENU_LINK,
  PATCH_MENU_LINK_SUCCESS,
  PATCH_MENUS_ITEM_SUCCESS,
  CLEAR_PATCH_MENU_LINK,
  PATCH_MENUS_ITEM_ERROR,
  CLEAR_PATCH_MENUS_ITEM,
  CREATE_MENUS_ITEM_SUCCESS,
  CREATE_MENUS_ITEM_ERROR,
  CLEAR_CREATE_MENUS_ITEM,
  DELETE_MENUS_ITEM_SUCCESS,
  DELETE_MENUS_iTEM_ERROR,
  CLEAR_DELETE_MENUS_ITEM,
  APPLY_MENU_LINK_DRAG,
  APPLY_MENU_LINK_DRAG_ERROR,
  CLEAR_MENU_LINK_DRAG,
  ADD_MENUS_IMAGES_SUCCESS,
  ADD_MENUS_IMAGES_ERROR,
  CLEAR_ADD_MENUS_IMAGES,
  DELETE_IMAGES_SUCCESS,
  DELETE_IMAGES_ERROR,
  CLEAR_DELETE_IMAGES,
} from 'redux/menu-links/types';

const initialState = {
  createMenuLinkSucces: null,
  createMenuLinkError: null,
  menuLinksList: null,
  menuLinksListError: null,
  deleteMenuLinkSuccess: null,
  deleteMenuLinkError: null,
  patchMenuLinkSuccess: null,
  patchMenuLinkError: null,
  menusItemDescription: null,
  patchMenusItemSuccess: null,
  createMenusItemSuccess: null,
  createMenusItemError: null,
  deleteMenusItemSuccess: null,
  deleteMenusItemError: null,
  addImagesSuccess: null,
  addImagesError: null,
  deleteImagesSuccess: null,
  deleteImagesError: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case FETCH_MENU_LINKS_LIST:
      return {
        ...state,
        menuLinksList: action.payload.data,
        menuLinksListError: null,
      };
    case FETCH_MENU_LINKS_LIST_ERROR:
      return {
        ...state,
        menuLinksList: null,
        menuLinksListError: action.payload.data,
      };
    case CLEAR_FETCH_MENU_LINKS_LIST:
      return {
        ...state,
        menuLinksList: null,
        menuLinksListError: null,
      };
    case CREATE_MENU_LINK_SUCCESS:
      return {
        ...state,
        menuLinksList: state.menuLinksList.concat(action.payload.data),
        createMenuLinkError: null,
      };
    case CREATE_MENU_LINK_ERROR:
      return {
        ...state,
        createMenuLinkSuccess: null,
        createMenuLinkError: action.payload.data,
      };
    case CLEAR_CREATE_MENU_LINK:
      return {
        ...state,
        createMenuLinkSuccess: null,
        createMenuLinkError: null,
      };
    case DELETE_MENU_LINK_SUCCESS:
      return {
        ...state,
        deleteMenuLinkSuccess: action.payload.data,
        deleteMenuLinkError: null,
      };
    case DELETE_MENU_LINK_ERROR:
      return {
        ...state,
        deleteMenuLinkSuccess: null,
        deleteMenuLinkError: action.payload.data,
      };
    case CLEAR_DELETE_MENU_LINK:
      return {
        ...state,
        deleteMenuLinkSuccess: null,
        deleteMenuLinkError: null,
      };
    case PATCH_MENU_LINK_SUCCESS: //update menu title
      return {
        ...state,
        patchMenuLinkError: null,
        menuLinksList: state.menuLinksList.map((item) => {
          if (item.id === action.payload.data.id) {
            return action.payload.data;
          }
          return item;
        }),
      };
    case PATCH_MENUS_ITEM_SUCCESS: //change item description and price
      return {
        ...state,
        patchMenusItemSuccess: action.payload.data,
      };
    case CLEAR_PATCH_MENUS_ITEM:
      return {
        ...state,
        patchMenusItemSuccess: null,
        patchMenusItemError: null,
      };

    case CREATE_MENUS_ITEM_SUCCESS:
      return {
        ...state,
        createMenusItemSuccess: action.payload.data,
        createMenusItemError: null,
      };
    case CREATE_MENUS_ITEM_ERROR:
      return {
        ...state,
        createMenusItemSuccess: null,
        createMenusItemError: action.payload.data,
      };
    case CLEAR_CREATE_MENUS_ITEM:
      return {
        ...state,
        createMenusItemSuccess: null,
        createMenusItemError: null,
      };
    case DELETE_MENUS_ITEM_SUCCESS:
      return {
        ...state,
        deleteMenusItemSuccess: action.payload.data,
        deleteMenusItemError: null,
      };
    case DELETE_MENUS_iTEM_ERROR:
      return {
        ...state,
        deleteMenusItemSuccess: null,
        deleteMenusItemError: action.payload.data,
      };
    case CLEAR_DELETE_MENUS_ITEM:
      return {
        ...state,
        deleteMenusItemSuccess: null,
        deleteMenusItemError: null,
      };
    case APPLY_MENU_LINK_DRAG:
      return {
        ...state,
        menuLinkDrugSuccess: action.payload.data,
        menuLinkDrugError: null,
      };
    case APPLY_MENU_LINK_DRAG_ERROR:
      return {
        ...state,
        menuLinkDrugSuccess: null,
        menuLinkDrugError: action.payload.data,
      };
    case CLEAR_MENU_LINK_DRAG:
      return {
        ...state,
        menuLinkDrugSuccess: null,
        menuLinkDrugError: null,
      };

    case ADD_MENUS_IMAGES_SUCCESS:
      return {
        ...state,
        addImagesSuccess: action.payload.data,
        addImagesError: null,
      };
    case ADD_MENUS_IMAGES_ERROR:
      return {
        ...state,
        addImagesSuccess: null,
        addImagesError: action.payload.data,
      };
    case CLEAR_ADD_MENUS_IMAGES:
      return {
        ...state,
        addImagesSuccess: null,
        addImagesError: null,
      };

    case DELETE_IMAGES_SUCCESS:
      return {
        ...state,
        deleteImagesSuccess: action.payload.data,
        deleteImagesError: null,
      };
    case DELETE_IMAGES_ERROR:
      return {
        ...state,
        deleteImagesSuccess: null,
        deleteImagesError: action.payload.data,
      };
    case CLEAR_DELETE_IMAGES:
      return {
        ...state,
        deleteImagesSuccess: null,
        deleteImagesError: null,
      };

    default:
      return state;
  }
};
